
<template>
    <button 
    :class="myClass"
    :type="type" 
    @click='clicked' >{{label}}</button>
    
</template>

<script>
import { ref } from "vue";

export default {
  props: {

    
    type:{type:String,default:'button'},
    class:{type:String,default:'btn btn-mag'},
    label: String,
    click: Function,
  },
  setup(props) {
    const myType = ref(props.type);
    const myLabel = ref(props.label);
    // console.log('props.class',props.class)

    let myClass = ref(props.class);

    if(myClass.value!="btn btn-red"){
      // Ich muss nur red oder white schreiben
      myClass.value="btn btn-"+myClass.value

    }

    


function clicked(){
  // emit("click")

  }


    return {
      myType,
      myLabel,
      myClass,
      clicked
    };
  },        
};
</script>





